import { useTranslation } from "react-i18next";

export const LangSwitcher = () => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language?.toLowerCase().split("-")[0];
  const nextLang = currentLang === "mk" ? "en" : "mk";

  const handleClick = () => i18n.changeLanguage(nextLang);

  return (
    <div className="mdl-header__lang" onClick={handleClick}>
      {nextLang.toUpperCase()}
    </div>
  );
};
